module.exports = __webpack_public_path__ + "img/2025-06-11d_4.a7844c16.jpg";